import { render, staticRenderFns } from "./SpecMeasurementDrop.vue?vue&type=template&id=8b8ab05c"
import script from "./SpecMeasurementDrop.vue?vue&type=script&lang=js"
export * from "./SpecMeasurementDrop.vue?vue&type=script&lang=js"
import style0 from "./SpecMeasurementDrop.vue?vue&type=style&index=0&id=8b8ab05c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports